<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
              span.white--text  Bítacora
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-flex(xs12 style='margin-top: 5px;')
          v-layout(wrap style='justify-content: space-between;')
            v-flex(xs3)
              v-text-field(v-model='search', label='Buscar')
            v-flex(xs3 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:disabled="resultadosres.length == 0" :items='filtros' v-model="seleccionFiltro" label="Usuarios" @change='cambiarFiltro()')
            v-flex(xs3 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:disabled="resultadosres.length == 0" :items='modulos' v-model="seleccionFiltroB" label="Modulos" @change='cambiarFiltro()')
            v-flex(xs2 style='display: flex;align-items: center;justify-content: flex-end;')
              v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                template(v-slot:activator='{ on, attrs }')
                  v-text-field(v-model='dateRangeText' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' v-on='on')
                v-date-picker(multiple v-model='dates' no-title='' dark='')
                  v-spacer
                  v-btn(text='' color='primary' @click='$refs.menu1.save(dates)')
                    | OK
              v-btn.mx-0(icon @click='buscarFecha' style='background: white;border-radius: 100%;margin-left:10px !important;').elevation-4
                v-icon(color='#d50d10' style='font-size: 1.70rem;') search
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Registros
        v-data-table.elevation-1(:headers='headers' :pagination.sync="pagination" :search='search' :items="resultados" style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ transform(props.item.fecha)}}
            td(v-if='props.item.usuario') {{ props.item.usuario.nombre + ' ' +props.item.usuario.apellido  }}
            td(v-else) N/A
            td {{ props.item.modulo }}
            td {{ props.item.accion }}
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
export default {
  name: "Bítacora",
  data: vm => ({
    ruta: serverImg,
    dates: [],
    data: [],
    loading: false,
    dialog4: false,
    modulos:[
      "Todos",
      "Cobros",
      "Valijas",
      "Movimientos",
      "Devoluciones",
    ],
    seleccionFiltro: 'Todos',
    seleccionFiltroB: 'Todos',
    filtros: [
      {
        text: "Todos",
        value: "Todos"
      },
    ],
    pagination: {
      sortBy: 'fecha', // The field that you're sorting by
      descending: true
    },
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    modal: false,
    search: "",
    dialog: false,
    resultadosres: [],
    resultados: [],
    headers: [
      { text: "Fecha", value: "fecha" },
      { text: "Usuario", value: "usuario" },
      { text: "Módulo", value: "modulo" },
      { text: "Acción", value: "accion" },
    ],
    cre: "",
    mod: "",
    elm: ""
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    dateRangeText () {
      let todos = []
      let desde
      let hasta
      if (this.dates && this.dates[0])  {
        desde = this.formatDate(this.dates[0])
        todos.push(desde)
      }
      if (this.dates && this.dates[1]) {
        hasta = this.formatDate(this.dates[1])
        todos.push(hasta)
      }
      return todos.join(' ~ ')
    },
  },
  watch: {
    dates (val) {
      if (val && val.length > 2) {
        let res = []
        res.push(val[0])
        res.push(val[2])
        this.$nextTick(() => {
          this.dates = res
        })
      }
      if (val && val.length == 2 && val[0] > val[1]) {
        this.$swal.fire(
          "¡Atención!",
          "La fecha final debe ser mayor a la fecha inicial.",
          "error"
        );
        let res = []
        res.push(val[0])
        this.$nextTick(() => {
          this.dates = res
        })
      }
    },
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
  },
  created() {
    let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
    let hasta = this.$moment().format('YYYY-MM-DD')
    this.dates.push(desde)
    this.dates.push(hasta)
    this.verificacion();
    this.initialize();
  },
  methods: {
    transform(date) {
      return this.$moment(date).utc().format("DD/MM/YYYY H:mm A")
    },
    aplicarFiltros() {
      let filtroB = this.seleccionFiltroB;
      let filtroE = this.seleccionFiltro;

      // Reiniciar resultados
      this.resultados = [];
      
      // Filtrar resultados
      this.resultados = this.resultadosres.filter(el => {
        const cumpleFiltroB = (filtroB === "Todos" || el.modulo === filtroB);
        const cumpleFiltroE = (filtroE === "Todos" || el.usuario._id.toString() === filtroE);
        return cumpleFiltroB && cumpleFiltroE;
      });
    },
    cambiarFiltro() {
      this.aplicarFiltros();
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminsafiro.permisos.length; i++) {
        if (this.$store.state.adminsafiro.permisos[i].ruta === "Bitacora") {
          for (
            let j = 0;
            j < this.$store.state.adminsafiro.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    buscarFecha() {
      this.dialog4 = true
      let hasta = (this.dates && this.dates[1]) ? this.dates[1] : null
      if (this.dates && this.dates[0]) {
        this.seleccionFiltro = 'Todos'
        this.seleccionFiltroB = 'Todos'
        this.resultados = [];
        this.resultadosres = [];
        Api.get("bitacora/admin?desde="+this.dates[0]+'&hasta='+hasta)
        .then(res => {
          this.$nextTick(() => {
            if (res.data && res.data.length > 0) {
              for (let i = 0; i < res.data.length; i++) {
                const el = res.data[i];
                this.resultados.push(el)
                this.resultadosres.push(el)
              }
            }
            this.dialog4 = false
          })
        }).catch(err=>{
          console.log(err)
          this.dialog4 = false
        })
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debes seleccionar al menos una fecha para realizar la operación",
          "error"
        );
      }
    },
    initialize() {
      this.date = new Date().toISOString().substr(0, 10)
      this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10))
      this.dates = []
      let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
      let hasta = this.$moment().format('YYYY-MM-DD')
      this.dates.push(desde)
      this.dates.push(hasta)
      this.dialog4 = true;
      this.filtros = [
        {
          text: "Todos",
          value: "Todos"
        }
      ]
      Api.get("admin").then(res => {
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            this.filtros.push({
              text: el.nombre +' '+ el.apellido,
              value: el._id.toString()
            })
          }
        }
      }).catch(err=>{
        console.log(err)
      });
      Api.get("bitacora/admin?desde="+this.dates[0]+'&hasta='+this.dates[1]).then(res => {
        this.resultados = [];
        this.resultadosres = [];
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            this.resultados.push(el)
            this.resultadosres.push(el)
          }
        }
        this.dialog4 = false;
      }).catch(err=>{
        this.dialog4 = false;
        console.log(err)
      });
    },
  }
};
</script>
<style lang="scss">
</style>
